import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useTheme } from '../../context/ThemeContext';
import styles from './PageLoader.module.scss';

const PageLoader = ({ 
  message = 'Loading...', 
  size = 48, 
  showOverlay = true,
  className = '' 
}) => {
  const { isDarkMode } = useTheme();

  const muiTheme = createTheme({
    palette: {
      mode: isDarkMode ? 'dark' : 'light',
      primary: {
        main: '#e36250 !important',
      },
      secondary: {
        main: '#8b5cf6',
      },
    },
  });

  if (showOverlay) {
    return (
      <ThemeProvider theme={muiTheme}>
        <Box className={`${styles.overlayContainer} ${className}`}>
          <Box className={styles.loaderCard}>
            <CircularProgress size={size} className={styles.loaderSpinner} />
            <Typography variant="h6" className={styles.loaderText}>
              {message}
            </Typography>
          </Box>
        </Box>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={muiTheme}>
      <Box className={`${styles.inlineContainer} ${className}`}>
        <CircularProgress size={size} className={styles.loaderSpinner} />
        <Typography variant="h6" className={styles.loaderText}>
          {message}
        </Typography>
      </Box>
    </ThemeProvider>
  );
};

export default PageLoader;
